import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Typography, Form, Row, Col, Modal, Space, Pagination, message, Dropdown, Menu } from 'antd';
import dayjs from 'dayjs';
import { AntdButton } from '../../../blueplanitUtils/InputField';
import { CustomGridTable } from '../../../blueplanitUtils/CustomGridTable';
import AssetWorkHistory from './AssetWorkHistory';
import AddWarrantyModal from './AddWarrantyModal';
import EditWarrantyModal from './EditWarrantyModal';
import FilterWarrantyComponent from './FilterWarrantyComponent';
import { setLoader } from '../../../Slices/loaderSlice';
import { getAllAssets, softDeleteAsset } from '../../../Slices/assetSlice';
import { S3ACCESSURL } from '../../../databucket';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudDownload, faEye, faFilter, faPen, faTrash } from '@fortawesome/free-solid-svg-icons';
const { Title } = Typography;

const ListOfWarranties = () => {
    const [filterForm] = Form.useForm();
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
    const [totalAssets, setTotalAssets] = useState(0);
    const [allAssets, setAllAssets] = useState([]);
    const [assetList, setAssetList] = useState([]);
    const [filters, setFilters] = useState({});
    const [showFilters, setShowFilters] = useState(false);
    const [selectedAsset, setSelectedAsset] = useState(null);
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const [isWarrantyModalOpen, setIsWarrantyModalOpen] = useState(false);
    const [isViewModalOpen, setIsViewModalOpen] = useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [WarrentyAssets, setWarrentyAssets] = useState([]);
    const [viewAttachments, setViewAttachments] = useState([]);
    const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails);
    const AllAssets = useSelector((state) => state.Assets.allAssets)

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getAllAssets({
            page: pagination.current,
            pageSize: pagination.pageSize,
            filters
        }));
    }, [dispatch, pagination, filters]);

    useEffect(() => {
        if (AllAssets && AllAssets.records && Array.isArray(AllAssets.records)) {
            const activeAssets = AllAssets.records.filter(asset => {
                if (asset.status !== true) return false;

                const hasValidWarrantyDuration = asset.warrantyDuration !== null &&
                    asset.warrantyDuration !== undefined &&
                    asset.warrantyDuration !== '' &&
                    !isNaN(asset.warrantyDuration) &&
                    parseFloat(asset.warrantyDuration) > 0;

                return hasValidWarrantyDuration;
            });
            setWarrentyAssets(activeAssets);
            setAllAssets(activeAssets);

            if (Object.keys(filters).length > 0) {
                const today = dayjs().startOf('day');
                const expiredFrom = filters.expiredDateFrom
                    ? dayjs(filters.expiredDateFrom).startOf('day')
                    : null;
                const expiredTo = filters.expiredDateTo
                    ? dayjs(filters.expiredDateTo).endOf('day')
                    : null;
                const filteredAssets = activeAssets.filter(asset => {
                    const purchaseDate = dayjs(parseInt(asset.purchaseDate));
                    const warrantyInMonths = parseFloat(asset.warrantyDuration);
                    const hasValidWarrantyData = purchaseDate.isValid() && !isNaN(warrantyInMonths);
                    const expiredDate = hasValidWarrantyData ? purchaseDate.add(warrantyInMonths, 'months').endOf('day') : null;
                    if (filters.warrantyStatus) {
                        if (!hasValidWarrantyData) {
                            return false;
                        }
                        const isExpired = expiredDate.isBefore(today) || expiredDate.isSame(today, 'day');
                        const isActive = expiredDate.isAfter(today);
                        if (filters.warrantyStatus === 'expired') {
                            if (!isExpired) {
                                return false;
                            }
                        } else if (filters.warrantyStatus === 'active') {
                            if (!isActive) {
                                return false;
                            }
                        } else if (filters.warrantyStatus === 'all') {
                        }
                    }
                    if ((expiredFrom || expiredTo) && !hasValidWarrantyData) {
                        return false;
                    }
                    if (hasValidWarrantyData) {
                        if (expiredFrom && expiredDate.isBefore(expiredFrom)) {
                            return false;
                        }
                        if (expiredTo && expiredDate.isAfter(expiredTo)) {
                            return false;
                        }
                    }
                    if (filters.assetTagId) {
                        const matches = asset.assetTagId?.toLowerCase().includes(filters.assetTagId.toLowerCase());
                        if (!matches) return false;
                    }
                    if (filters.purchasedFrom) {
                        const matches = asset.purchasedFrom?.toLowerCase().includes(filters.purchasedFrom.toLowerCase());
                        if (!matches) return false;
                    }
                    if (filters.productName) {
                        const matches = asset.productName?.toLowerCase().includes(filters.productName.toLowerCase());
                        if (!matches) return false;
                    }
                    return true;
                });
                setAssetList(filteredAssets);
                setTotalAssets(filteredAssets.length);
            } else {
                setAssetList(activeAssets);
                setTotalAssets(activeAssets.length);
            }
        }
    }, [AllAssets, filters]);

    useEffect(() => {
        dispatch(setLoader());
    }, [dispatch]);

    const openEditModal = (asset) => {
        setSelectedAsset(asset);
        setIsEditModalOpen(true);
    };
    const showAttachmentsModal = (attachments) => {
        setViewAttachments(attachments);
        setIsWarrantyModalOpen(true);
    };

    const closeViewModal = () => {
        setSelectedAsset(null);
        setIsViewModalOpen(false);
    };

    const handleSearch = (values) => {


        const filtersToApply = Object.keys(values).reduce((acc, key) => {
            if (values[key] !== null && values[key] !== undefined && values[key] !== '') {
                acc[key] = values[key];
            }
            return acc;
        }, {});

        const today = dayjs().startOf('day');
        const expiredFrom = filtersToApply.expiredDateFrom
            ? dayjs(filtersToApply.expiredDateFrom).startOf('day')
            : null;

        const expiredTo = filtersToApply.expiredDateTo
            ? dayjs(filtersToApply.expiredDateTo).endOf('day')
            : null;

        const filteredAssets = allAssets.filter(asset => {

            const purchaseDate = dayjs(parseInt(asset.purchaseDate));
            const warrantyInMonths = parseFloat(asset.warrantyDuration);
            const hasValidWarrantyData = purchaseDate.isValid() && !isNaN(warrantyInMonths);

            const expiredDate = hasValidWarrantyData ? purchaseDate.add(warrantyInMonths, 'months').endOf('day') : null;


            if (filtersToApply.warrantyStatus) {

                if (!hasValidWarrantyData) {
                    return false;
                }

                const isExpired = expiredDate.isBefore(today) || expiredDate.isSame(today, 'day');
                const isActive = expiredDate.isAfter(today);


                if (filtersToApply.warrantyStatus === 'expired') {
                    if (!isExpired) {
                        return false;
                    }
                } else if (filtersToApply.warrantyStatus === 'active') {
                    if (!isActive) {
                        return false;
                    }
                } else if (filtersToApply.warrantyStatus === 'all') {
                }
            }

            if ((expiredFrom || expiredTo) && !hasValidWarrantyData) {
                return false;
            }

            if (hasValidWarrantyData) {
                if (expiredFrom && expiredDate.isBefore(expiredFrom)) {
                    return false;

                }
                if (expiredTo && expiredDate.isAfter(expiredTo)) {
                    return false;
                }
            }

            if (filtersToApply.assetTagId) {
                const matches = asset.assetTagId?.toLowerCase().includes(filtersToApply.assetTagId.toLowerCase());
                if (!matches) return false;
            }


            if (filtersToApply.purchasedFrom) {
                const matches = asset.purchasedFrom?.toLowerCase().includes(filtersToApply.purchasedFrom.toLowerCase());
                if (!matches) return false;
            }


            if (filtersToApply.productName) {
                const matches = asset.productName?.toLowerCase().includes(filtersToApply.productName.toLowerCase());
                if (!matches) return false;
            }

            return true;
        });

        setFilters(filtersToApply);
        setPagination(prev => ({ ...prev, current: 1 }));
        setAssetList(filteredAssets);
        setTotalAssets(filteredAssets.length);
    };


    const handleClear = () => {
        filterForm.resetFields();
        setFilters({});
        setAssetList(allAssets);
        setPagination(prev => ({ ...prev, current: 1 }));
        setTotalAssets(allAssets.length);
    };

    const handleDelete = (id) => {
        Modal.confirm({
            title: 'Are you sure you want to delete this asset?',
            okText: 'Yes',
            cancelText: 'No',
            onOk: async () => {
                try {
                    const result = await dispatch(softDeleteAsset({
                        id,
                        userName: `${loginUser?.firstname} ${loginUser?.lastname}`,
                        editedAt: new Date().toISOString(),
                    }));

                    if (softDeleteAsset.fulfilled.match(result)) {
                        setAssetList((prev) => prev.filter((item) => item.id !== id));
                        message.success('Asset deleted successfully!');
                    } else {
                        message.error('Deletion failed!');
                    }
                } catch (err) {
                    message.error('Failed to delete asset');
                }
            },
        });
    };

    const exportColumns = [
        'sno',
        'assetTagId',
        'productName',
        'cost',
        'brand',
        'model',
        'purchasedFrom',
        'purchaseDate',
        'expiredDate',
        'warrantyDuration',
    ];

    const handleExport = (fileFormat, selectedColumns, data) => {
        if (!data || data.length === 0) {
            message.info("No data available for export.");
            return;
        }

        const dataToExport = data.map((row, index) => {
            const sno = (pagination.current - 1) * pagination.pageSize + index + 1;

            const exportRow = {
                ...row,
                sno,
                purchaseDate: row.purchaseDate
                    ? dayjs(Number(row.purchaseDate)).isValid()
                        ? dayjs(Number(row.purchaseDate)).format('DD/MM/YYYY')
                        : ''
                    : '',
            };
            if (selectedColumns.includes('expiredDate')) {
                exportRow.expiredDate = calculateExpiredDate(row.purchaseDate, row.warrantyDuration);
            }

            return exportRow;
        });

        if (fileFormat === 'CSV') {
            const csvData = convertToCSV(dataToExport, selectedColumns);
            downloadCSV(csvData, 'Assets_Report.csv');
        } else if (fileFormat === 'PDF') {
            simulatePrintDialog(dataToExport, selectedColumns);
        }
    };


    const convertToCSV = (data, selectedColumns) => {
        const headers = selectedColumns.join(',') + '\n';
        const rows = data.map(row =>
            selectedColumns.map(col => `"${row[col] ?? ''}"`).join(',')
        );
        return headers + rows.join('\n');
    };

    const downloadCSV = (csv, filename) => {
        const blob = new Blob([csv], { type: 'text/csv' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const simulatePrintDialog = (dataToExport, selectedColumns) => {
        const printableContent = document.createElement("div");
        printableContent.id = "print-content";

        const table = document.createElement("table");
        table.style.width = "100%";
        table.style.border = "1px solid #000";
        table.style.borderCollapse = "collapse";

        const thead = document.createElement("thead");
        const headerRow = document.createElement("tr");

        selectedColumns.forEach(col => {
            const th = document.createElement("th");
            th.innerText = col;
            th.style.border = "1px solid #000";
            th.style.padding = "5px";
            headerRow.appendChild(th);
        });
        thead.appendChild(headerRow);
        table.appendChild(thead);

        const tbody = document.createElement("tbody");
        dataToExport.forEach(row => {
            const tr = document.createElement("tr");
            selectedColumns.forEach(col => {
                const td = document.createElement("td");
                td.innerText = row[col] || '';
                td.style.border = "1px solid #ccc";
                td.style.padding = "5px";
                tr.appendChild(td);
            });
            tbody.appendChild(tr);
        });

        table.appendChild(tbody);
        printableContent.appendChild(table);

        const style = document.createElement("style");
        style.innerHTML = `
    body * { visibility: hidden; }
    #print-content, #print-content * { visibility: visible; }
    #print-content { position: absolute; top: 0; left: 0; width: 100%; }
  `;
        document.head.appendChild(style);
        document.body.appendChild(printableContent);
        window.print();
        document.body.removeChild(printableContent);
        document.head.removeChild(style);
    };

    const calculateExpiredDate = (purchaseDate, warrantyDuration) => {
        const warrantyInMonths = parseInt(warrantyDuration, 10);
        if (purchaseDate && !isNaN(warrantyInMonths)) {
            const parsedDate = dayjs(parseInt(purchaseDate));
            if (parsedDate.isValid()) {
                return parsedDate.add(warrantyInMonths, 'months').format('DD/MM/YYYY');
            }
        }
        return 'N/A';
    };

    const columns = [
        {
            title: 'S.No',
            key: 'sno',
            align: 'center',
            render: (_, __, index) =>
                (pagination.current - 1) * pagination.pageSize + index + 1,
        },
        { title: 'Asset Tag ID', dataIndex: 'assetTagId', align: 'center' },
        { title: 'Product Name', dataIndex: 'productName', align: 'center' },
        { title: 'Purchased From', dataIndex: 'purchasedFrom', align: 'center' },

        {
            title: 'Purchase Date',
            dataIndex: 'purchaseDate',
            align: 'center',
            render: (date) => dayjs(parseInt(date)).format('DD/MM/YYYY'),
        },

        {
            title: 'Expired Date',
            align: 'center',
            render: (_, record) => calculateExpiredDate(record.purchaseDate, record.warrantyDuration),
        },

        {
            title: 'Warranty In Months', dataIndex: 'warrantyDuration',
            align: 'center',
            render: (warrantyDuration) => warrantyDuration ? `${warrantyDuration}` : 'N/A',
        },

        {
            title: 'Warranty Attachments',
            dataIndex: 'warrantyAttachments',
            align: 'center',
            render: (warrantyAttachments, row) => {
                const activeWarrantyAttachments = warrantyAttachments?.filter(att => att.status === true);

                if (!activeWarrantyAttachments || activeWarrantyAttachments.length === 0) {
                    return 'No File';
                }

                return (
                    <button
                        onClick={() => showAttachmentsModal(activeWarrantyAttachments, row)}
                        style={{
                            background: 'none',
                            border: 'none',
                            padding: 0,
                            color: '#1890ff',
                            cursor: 'pointer',
                            font: 'inherit',
                            textDecoration: 'underline'
                        }}
                    >
                        View <FontAwesomeIcon icon={faEye} />
                    </button>

                );
            }
        },

        {
            title: 'Actions',
            key: 'actions',
            align: 'center',
            render: (_, record) => (
                <Space>
                    <FontAwesomeIcon icon={faEye}
                        style={{ fontSize: 14, color: '#000', cursor: 'pointer' }}
                        onClick={() => {
                            setSelectedAsset(record);
                            setIsViewModalOpen(true);
                        }}
                    />
                    <FontAwesomeIcon icon={faPen}
                        style={{ fontSize: 14, color: '#1890ff', cursor: 'pointer' }}
                        onClick={() => openEditModal(record)}
                    />
                    <FontAwesomeIcon icon={faTrash}
                        style={{ fontSize: 14, color: '#ff4d4f', cursor: 'pointer' }}
                        onClick={() => handleDelete(record.id)}
                    />
                </Space>
            )
        },
    ];


    return (
        <div style={{ padding: 24, marginTop: 20 }}>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginBottom: 6 }}>
                <AntdButton type="primary" label="Add Warranty" onClick={() => setIsAddModalOpen(true)} />
                <AntdButton type="primary" label="Filters" onClick={() => setShowFilters(prev => !prev)} icon={<FontAwesomeIcon icon={faFilter} />} />
                <Dropdown
                    overlay={
                        <Menu
                            onClick={({ key }) => handleExport(key, exportColumns, assetList)}
                            items={[
                                { key: 'CSV', label: 'Export as CSV' },
                                { key: 'PDF', label: 'Export as PDF' },
                            ]}
                        />
                    }
                    trigger={['click']}
                >
                    <AntdButton type="primary" label="Export" icon={<FontAwesomeIcon icon={faCloudDownload} />} />
                </Dropdown>
            </div>
            <Modal
                title="Warranty Attachments"
                open={isWarrantyModalOpen}
                onCancel={() => setIsWarrantyModalOpen(false)}
                footer={null}
                width={800}
            >
                {viewAttachments.length > 0 ? (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16 }}>
                        {viewAttachments.map((file, index) => {
                            const isImage = file.filename?.toLowerCase().match(/\.(jpg|jpeg|png|gif|bmp|webp|svg)$/);

                            return (
                                <div key={index} style={{
                                    border: '1px solid #f0f0f0',
                                    borderRadius: '8px',
                                    padding: '12px',
                                    backgroundColor: '#fafafa'
                                }}>
                                    <div style={{ marginBottom: '8px' }}>
                                        <a
                                            href={S3ACCESSURL + file.data}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{
                                                color: '#1890ff',
                                                textDecoration: 'underline',
                                                fontWeight: '500'
                                            }}
                                        >
                                            {file.filename}
                                        </a>
                                    </div>
                                    {isImage && (
                                        <div style={{ marginBottom: '16px' }}>
                                            <img
                                                src={`${S3ACCESSURL}${file.url || file.data}`}
                                                alt={file.filename}
                                                style={{
                                                    maxWidth: '%',
                                                    maxHeight: 100,
                                                    borderRadius: 6,
                                                    display: 'block'
                                                }}
                                                onClick={() => window.open(`${S3ACCESSURL}${file.url || file.data}`, '_blank')}
                                                onError={(e) => {
                                                    e.target.style.display = 'none';
                                                    e.target.nextSibling.style.display = 'block';
                                                }}
                                            />
                                            <div style={{
                                                display: 'none',
                                                color: '#999',
                                                fontStyle: 'italic',
                                                textAlign: 'center',
                                                padding: '20px'
                                            }}>
                                                Image preview not available
                                            </div>
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                ) : (
                    <p>No attachments found.</p>
                )}
            </Modal>
            <Row gutter={30}>
                {showFilters && (
                    <Col span={6} style={{ marginTop: '-60px', marginLeft: '-30px' }}>
                        <FilterWarrantyComponent
                            showFilters={showFilters}
                            onClose={() => setShowFilters(false)}
                            onSearch={handleSearch}
                            onClear={handleClear}
                            form={filterForm}
                        />
                    </Col>
                )}

                <Col span={showFilters ? 18 : 24}
                    style={{ marginLeft: showFilters ? -30 : 0 }} >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                        <Title level={3} style={{ margin: 0 }}>List of Warranties</Title>
                        {Object.keys(filters).length > 0 && (
                            <span style={{ color: '#666', fontSize: '14px' }}>
                                Showing {assetList.length} filtered results
                            </span>
                        )}
                    </div>
                    <CustomGridTable
                        columns={columns}
                        Id="list-of-warranties-table"
                        dataSource={Object.keys(filters).length > 0 ? assetList : WarrentyAssets}
                        pagination={false}
                        borderedy
                        size="small"
                        rowKey="id"
                    />
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
                        <Pagination
                            current={pagination.current}
                            pageSize={pagination.pageSize}
                            total={totalAssets}
                            onChange={(page) => {
                                setPagination(prev => ({ ...prev, current: page }));

                            }}
                            showSizeChanger={false}
                            size="small"
                        />
                    </div>
                </Col>
            </Row>

            <AddWarrantyModal
                isOpen={isAddModalOpen}
                onClose={() => setIsAddModalOpen(false)}
                onSuccess={() => {
                    setIsAddModalOpen(false);
                }}
            />

            <EditWarrantyModal
                isOpen={isEditModalOpen}
                onClose={() => setIsEditModalOpen(false)}
                selectedAsset={selectedAsset}
                setSelectedAsset={setSelectedAsset}
                onSuccess={() => {
                }}
                pagination={pagination}
                filters={filters}
            />

            <AssetWorkHistory
                open={isViewModalOpen}
                onClose={closeViewModal}
                selectedAsset={selectedAsset}
            />
        </div >
    );
};

export default ListOfWarranties;